import { EXCLUDED_FETCH_URLS } from './excluded-urls'

export function shouldBeDiscardedFromLogs (log) {
  if (log?.status !== 'error') return false

  if (typeof log?.message === 'string'
    && log?.message?.includes('Script error.')
    && log?.error?.stack?.includes('at undefined @')
  ) {
    return true
  }

  // Closing attachable is done via promise rejection which when unhandled throws errors to console
  // - [attachable] closed with reason: *
  // - [attachable] closed
  if (typeof log?.message === 'string' && log?.message?.includes('[attachable] closed')) {
    return true
  }

  // External tracking scripts fetch errors
  if (typeof log?.message === 'string' && log?.message?.includes('Fetch error')) {
    const isExcludedUrl = EXCLUDED_FETCH_URLS.some(url => log.message.includes(url))
    if (isExcludedUrl) {
      return true
    }
  }

  // Type Error: Load failed.
  if (typeof log?.message === 'string' && log?.message === 'Load failed') {
    return true
  }

  // Type Error: { "componentRef": null }
  if (typeof log?.message === 'string' && log?.message?.includes('componentRef')) {
    return true
  }

  // UnknownError: Connection to Indexed Database server lost. Refresh the page to try again
  if (typeof log?.message === 'string' && log?.message?.includes('Connection to Indexed Database server lost. Refresh the page to try again')) {
    return true
  }

  return false
}
